// src/services/api.js
import { getCurrentUserId } from "shared/utils/SessionDataUtils";
import { v4 as uuidv4 } from 'uuid';
import { APIPath, baseURL } from "./APIPath";

// 🌳 Actual API calls (not mocked now)

// GET /tree?fruit=apple
export const fetchUser = () =>
  APIPath.post(baseURL + "/sync-user").then((r) => sessionStorage.setItem("app_userprofile", JSON.stringify(r.data)));

export const fetchUserByRole = async (role) => {
  console.log(role);

  try {
    let response;

    if (role === 'ROLE_TEACHER') {
      response = await APIPath.get(`${baseURL}/tutors?userId.equals=${getCurrentUserId()}`);
      console.log("User Role profile stored successfully.");
    } else if (role === 'ROLE_PARENT') {
      response = await APIPath.get(`${baseURL}/parents?userId.equals=${getCurrentUserId()}`);
      console.log("User Role Parent profile stored successfully.");
    } else if (role === 'ROLE_STUDENT') {
      const userProfile = JSON.parse(sessionStorage.getItem("keycloak_user_profile"));
      response = await APIPath.get(`${baseURL}/students?email.equals=${userProfile.email}`);
    }

    if (response && response.data && response.data[0]) {
      sessionStorage.setItem("app_role_userprofile", JSON.stringify(response.data[0]));
    } else {
      console.warn("No role-based user profile found.");
    }

  } catch (error) {
    console.error("Error fetching user by role:", error);
    throw error;
  }
};



export const fetchToken = async (username, password) => {
  const transactionId = uuidv4();
  try {
    const requestBody = { "transactionId": transactionId };
    const response = await APIPath.post(`${baseURL}/fetch-token`, requestBody);
    console.log(response.headers); // Axios returns a plain object

    const returnedTransactionId = response.headers["X-Transaction-Id"];
    console.log(returnedTransactionId + " " + transactionId);

    // if (returnedTransactionId === transactionId) {
    sessionStorage.setItem("app_masterdata_token", (response.data));
    console.log("Token stored successfully.");
    // } else {
    //   console.warn("Transaction ID mismatch. Token not stored.");
    // }
  } catch (error) {
    console.error("Failed to fetch token:", error);
  }
};


// GET /tree?fruit=apple
export const fetchTree = (fruit) =>
  APIPath.get("/tree", { params: { fruit } }).then((r) => r.data);

// POST /tree/metadata
export const updateMetadata = (payload) =>
  APIPath.post("/tree/metadata", payload).then((r) => r.data);

// POST /tree/configure
export const configureTree = (fruitType) =>
  APIPath.post("/tree/configure", { fruitType }).then((r) => r.data);
